import { SidebarModalListItem } from '@domain-group/suit-theme'

import { confirmDelete } from '@functions/entity'

import type { ImageSizePreset, UseDownloadMediaPayload } from '@modals/DownloadMediaModal/hooks/useDownloadMedia'
import type { UserModel } from '@models/types'

interface PresetProps {
  callbacks: {
    buildAgencyPresets: UseDownloadMediaPayload['callbacks']['buildAgencyPresets'],
    resetSelectedPreset: UseDownloadMediaPayload['callbacks']['resetSelectedPreset'],
    selectPreset: () => void,
    updateAgency: UseDownloadMediaPayload['callbacks']['updateAgency'],
  },
  currentUser?: UserModel,
  isPublicPage?: boolean,
  isSelected: boolean,
  preset: ImageSizePreset,
}

const Preset = (props: PresetProps) => {
  const {
    callbacks: {
      buildAgencyPresets, resetSelectedPreset, selectPreset, updateAgency,
    },
    currentUser,
    isPublicPage,
    isSelected,
    preset,
    preset: {
      isDefault, title, subtitle,
    },
  } = props

  const confirmDeletePayload = {
    callbacks: {
      afterAction: () => {
        if (isSelected) resetSelectedPreset()
      },
      deleteFn: updateAgency,
    },
    options: {
      entityParams: buildAgencyPresets(preset),
    },
    strings: {
      confirmString: 'Are you sure? This will remove the preset from this agency.',
      deleteString: 'Remove',
      entityName: 'Image Download Preset',
    },
  }

  return (
    <SidebarModalListItem
      checkboxOnClick={() => selectPreset()}
      isChecked={isSelected}
      secondaryText={subtitle}
      showCheckbox
      title={title}
    >
      {!isDefault && !isPublicPage && (
        // @ts-expect-error TS2339
        <SidebarModalListItem.Actions>
          {/*
           // @ts-expect-error TS2339 */}
          <SidebarModalListItem.Icon
            // @ts-expect-error TS2345
            onClick={() => confirmDelete(confirmDeletePayload)}
            type="delete"
          />
          {/*
         // @ts-expect-error TS2339 */}
        </SidebarModalListItem.Actions>
      )}
    </SidebarModalListItem>
  )
}

export default Preset
